/* istanbul ignore file */
import { canUseDOM, getWindow } from '@surfline/web-common';

/**
 * @param {Error} error
 */
const shouldIgnoreError = (error) => {
  const { message, stack } = error;

  // Only ignore script errors for Safari
  // These errors are related to third party script cross-origin errors
  // so we can safely ignore them.
  if (message?.includes('Script error')) {
    return true;
  }

  // If it's some unknown error originating from google SDK, then ignore it
  if (stack?.includes('imasdk.googleapis.com')) {
    return true;
  }

  if (
    (stack?.includes('.current is not a function') &&
      stack?.includes('https://wa.cdn-surfline.com/homepage/SurfCams-')) ||
    stack?.includes('https://product-cdn.staging.surfline.com/homepage/SurfCams-')
  ) {
    return true;
  }

  if (
    (stack?.includes('Failed to fetch') &&
      stack?.includes('https://wa.cdn-surfline.com/web-backplane')) ||
    stack?.includes('https://product-cdn.staging.surfline.com/web-backplane')
  ) {
    return true;
  }

  return false;
};

const setNewRelicErrorHandler = () => {
  if (canUseDOM) {
    const win = getWindow();

    if (win?.newrelic) {
      win.newrelic.setErrorHandler(shouldIgnoreError);
    }
  }
};

export default setNewRelicErrorHandler;
